import styled from "styled-components";

export const SessionTimerLabelDefaultBox = styled.div`
    padding-bottom: 0.5rem;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: inline-block;
        padding-right: 0.5rem;
        padding-bottom: 0;
    }
`;

export const SessionTimerLabelBox = SessionTimerLabelDefaultBox;